// ======================================================================
// File Name       : ContentSingleQuestionAdvanceSetting
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from "react";
import { Form, FormControl, Col } from "react-bootstrap";
import FileUpload from "../../components/FileUpload";
import FormControlValidate from "../FormControlValidate";
import { VALIDATE_TYPE } from "../../constants/index";

class ContentSingleQuestionAdvanceSetting extends React.Component {
  constructor() {
    super();
    this.validation = this.validation.bind(this);
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      (ref) =>
        this.refsToValidate[ref].validation &&
        this.refsToValidate[ref].validation(),
    );
  }

  render() {
    const {
      buttonText,
      questionViewDirection,
      absolutePoint,
      limitTime,
      sankakuUseDistinct,
      explanationUse,
      explanationHtmlUse,
      explanationContent,
      explanationZipFileName,
      hintUse,
      hintHtmlUse,
      hintContent,
      hintZipFileName,
      handleExplanationHtmlFileChange,
      handleHintHtmlFileChange,
      handleChange,
      handleCheckboxChange,
      openOrCloseAdvanceSetting,
      isClosedAdvanceSetting,
      questionUseForm,
    } = this.props;
    this.refsToValidate = [];
    const isExplanationHtmlUse = explanationHtmlUse === "1";
    const isHintHtmlUse = hintHtmlUse === "1";
    const isQuestionUseForm = questionUseForm === "1";
    return (
      <div>
        {!isQuestionUseForm && (
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={4}>
              問題・解答の表示方向
            </Col>
            <Col sm={4} className="padding-left-clear padding-top-10">
              <Form.Check
                type="radio"
                name="questionViewDirection"
                id="questionViewDirection-0"
                inline
                className="padding-top-clear"
                value={0}
                checked={questionViewDirection === "0"}
                onChange={handleChange}
                label="横書き"
              ></Form.Check>
            </Col>
            <Col sm={4} className="padding-left-clear padding-top-10">
              <Form.Check
                type="radio"
                name="questionViewDirection"
                id="questionViewDirection-1"
                inline
                className="padding-top-clear"
                value={1}
                checked={questionViewDirection === "1"}
                onChange={handleChange}
                label="縦書き"
              ></Form.Check>
            </Col>
          </Form.Group>
        )}
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={4}>
            配点
          </Col>
          <Col sm={7}>
            <FormControlValidate
              type="text"
              name="absolutePoint"
              value={absolutePoint}
              onChange={handleChange}
              maxLength="3"
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
              validateType={VALIDATE_TYPE.MAX_NUMBER}
              maxNumber="100"
              label="配点"
            />
          </Col>
          <Col sm={1} as={Form.Label} className="padding-left-right-clear">
            点
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={4}>
            制限時間
          </Col>
          <Col sm={7}>
            <FormControlValidate
              type="text"
              name="limitTime"
              value={limitTime}
              onChange={handleChange}
              maxLength="4"
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
              validateType={VALIDATE_TYPE.MAX_NUMBER}
              maxNumber="3600"
              label="制限時間"
            />
          </Col>
          <Col sm={1} as={Form.Label} className="padding-left-right-clear">
            秒
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={4}>
            △判定を使用する
          </Col>
          <Col sm={7} className="padding-top-10">
            <Form.Check
              type="checkbox"
              className="margin-left-30 padding-top-clear"
              checked={sankakuUseDistinct}
              name="sankakuUseDistinct"
              id="sankakuUseDistinct"
              onChange={handleCheckboxChange}
            />
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={4}>
            解答解説を使用する
          </Col>
          <Col sm={7} className="padding-top-10">
            <Form.Check
              type="checkbox"
              className="margin-left-30 padding-top-clear"
              checked={explanationUse}
              name="explanationUse"
              id="explanationUse"
              onChange={handleCheckboxChange}
            />
          </Col>
        </Form.Group>
        {explanationUse && (
          <Form.Group className="form-info">
            <Col sm={2} className="padding-left-right-clear" />
            <Col sm={2} as={Form.Label} className="padding-left-right-clear">
              内容
            </Col>
            <Col sm={7} className="padding-top-10">
              <Col sm={6} className="padding-left-right-clear">
                <Form.Check
                  type="radio"
                  name="explanationHtmlUse"
                  id="explanationHtmlUse-0"
                  inline
                  className="padding-top-clear"
                  value={0}
                  checked={explanationHtmlUse === "0"}
                  disabled={!explanationUse}
                  onChange={handleChange}
                  label="HTMLを使用しない"
                ></Form.Check>
              </Col>
              <Col sm={6}>
                <Form.Check
                  type="radio"
                  name="explanationHtmlUse"
                  id="explanationHtmlUse-1"
                  inline
                  className="padding-top-clear"
                  value={1}
                  checked={explanationHtmlUse === "1"}
                  disabled={!explanationUse}
                  onChange={handleChange}
                  label="HTMLを使用する"
                ></Form.Check>
              </Col>
            </Col>
            {!isExplanationHtmlUse && (
              <Col
                sm={{
                  span: 7,
                  offset: 4,
                }}
                className="margin-bottom-10"
              >
                <FormControlValidate
                  as="textarea"
                  className="textArea"
                  name="explanationContent"
                  label="内容"
                  disabled={!explanationUse}
                  onChange={handleChange}
                  value={explanationContent}
                  maxLength="30000"
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required={explanationUse && !isExplanationHtmlUse}
                />
              </Col>
            )}
            {isExplanationHtmlUse && (
              <Col
                sm={{
                  span: 7,
                  offset: 4,
                }}
                className="margin-top-10"
              >
                <FileUpload
                  labelName="ファイル選択"
                  inputId={"explanationHtmlFileUploadBtn"}
                  disabled={!explanationUse}
                  onChange={handleExplanationHtmlFileChange}
                  fileName={explanationZipFileName}
                  accept=".zip"
                />
              </Col>
            )}
            {isExplanationHtmlUse && explanationUse && (
              <Col
                sm={{
                  span: 7,
                  offset: 4,
                }}
                as={Form.Label}
              >
                <FormControlValidate
                  label="ファイル"
                  validateType={VALIDATE_TYPE.LABEL}
                  value={
                    explanationZipFileName &&
                    `ファイル名：${explanationZipFileName}`
                  }
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required
                />
              </Col>
            )}
          </Form.Group>
        )}

        <Form.Group className="form-info">
          <Col as={Form.Label} sm={4}>
            ヒントを使用する
          </Col>
          <Col sm={6} className="padding-top-10">
            <Form.Check
              type="checkbox"
              className="margin-left-30 padding-top-clear"
              checked={hintUse}
              name="hintUse"
              id="hintUse"
              onChange={handleCheckboxChange}
            />
          </Col>
        </Form.Group>
        {hintUse && (
          <Form.Group className="form-info">
            <Col sm={2} className="padding-left-right-clear" />
            <Col sm={2} className="padding-left-right-clear form-label">
              内容
            </Col>
            <Col sm={7} className="padding-top-10">
              <Col sm={6} className="padding-left-right-clear">
                <Form.Check
                  type="radio"
                  name="hintHtmlUse"
                  id="hintHtmlUse-0"
                  inline
                  className="padding-top-clear"
                  value={0}
                  disabled={!hintUse}
                  checked={hintHtmlUse === "0"}
                  onChange={handleChange}
                  label="HTMLを使用しない"
                ></Form.Check>
              </Col>
              <Col sm={6}>
                <Form.Check
                  type="radio"
                  name="hintHtmlUse"
                  id="hintHtmlUse-1"
                  inline
                  className="padding-top-clear"
                  value={1}
                  disabled={!hintUse}
                  checked={hintHtmlUse === "1"}
                  onChange={handleChange}
                  label="HTMLを使用する"
                ></Form.Check>
              </Col>
            </Col>
            {!isHintHtmlUse && (
              <Col sm={12} className="margin-top-10 padding-left-right-clear">
                <Col
                  sm={{
                    span: 7,
                    offset: 4,
                  }}
                  className="margin-bottom-10"
                >
                  <FormControlValidate
                    as="textarea"
                    className="textArea"
                    name="hintContent"
                    label="内容"
                    disabled={!hintUse}
                    onChange={handleChange}
                    value={hintContent}
                    required={hintUse && !isHintHtmlUse}
                    maxLength="30000"
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                  />
                </Col>
              </Col>
            )}
            {isHintHtmlUse && (
              <Col
                sm={{
                  span: 7,
                  offset: 4,
                }}
                className="margin-top-10"
              >
                <FileUpload
                  labelName="ファイル選択"
                  inputId={"hintZipFileNameUploadBtn"}
                  disabled={!hintUse}
                  onChange={handleHintHtmlFileChange}
                  fileName={hintZipFileName}
                  accept=".zip"
                />
              </Col>
            )}
            {isHintHtmlUse && hintUse && (
              <Col
                sm={{
                  span: 7,
                  offset: 4,
                }}
                as={Form.Label}
              >
                <FormControlValidate
                  label="ファイル"
                  validateType={VALIDATE_TYPE.LABEL}
                  value={hintZipFileName && `ファイル名：${hintZipFileName}`}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required
                />
              </Col>
            )}
          </Form.Group>
        )}
      </div>
    );
  }
}
export default ContentSingleQuestionAdvanceSetting;
